import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CopyToClipboardButton } from "ui/copy-to-clipboard-button";
import { SelectableFilesTable } from "@/entities/media-files";
import { CollectionFile } from "shared/types/files";

interface Props {
  files: CollectionFile[];
  selectedMediaSet: Map<string, CollectionFile>;
  onSelect(file: CollectionFile): void;
  onRemove(file: CollectionFile): void;
}

export function CollectionFilesTable(props: Props) {
  return (
    <TooltipProvider delayDuration={200}>
      <SelectableFilesTable
        files={props.files}
        onSelect={(file) => props.onSelect(file)}
        onRemove={(file) => props.onRemove(file)}
        isFileSelected={(file) => props.selectedMediaSet.has(file._id)}
        renderHeader={(HeadCell) => (
          <>
            <HeadCell>Filename</HeadCell>
            <HeadCell>Description</HeadCell>
            <HeadCell>Size</HeadCell>
            <HeadCell>Tags</HeadCell>
          </>
        )}
        renderFile={(file, TableCell) => (
          <>
            <TableCell>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="max-w-[100px] truncate">{file.name}</div>
                </TooltipTrigger>
                <TooltipContent>{file.name}</TooltipContent>
              </Tooltip>
            </TableCell>
            <TableCell>
              {file.description && (
                <div className="flex items-center">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="max-w-[246px] truncate mr-2.5">
                        {file.description}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>{file.description}</TooltipContent>
                  </Tooltip>
                  <div onClick={(e) => e.stopPropagation()}>
                    <CopyToClipboardButton text={file.description} />
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell>
              {file.meta.width &&
                file.meta.height &&
                `${file.meta.width}x${file.meta.height}`}
            </TableCell>
            <TableCell>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="cursor-help">{file.tags.length}</span>
                </TooltipTrigger>
                <TooltipContent>{file.tags.join(", ")}</TooltipContent>
              </Tooltip>
            </TableCell>
          </>
        )}
      />
    </TooltipProvider>
  );
}
